module.exports = __webpack_public_path__ + "images/dutchlease_small98b47d0333c8657ecf9136e35920be45.png";